import { BaseWebComponentController } from '../../../../../framework/BaseWebComponentController';
import { IntegrityMonitorDirectoryRuleFormWebComponent } from '../component/IntegrityMonitorDirectoryRuleFormWebComponent';
import { IntegrityMonitorDirectoryRuleFormView } from '../view/IntegrityMonitorDirectoryRuleFormView';
import { template } from '../view/template';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';

export class IntegrityMonitorDirectoryRuleFormController extends BaseWebComponentController {
  public view!: IntegrityMonitorDirectoryRuleFormView;

  constructor(component: IntegrityMonitorDirectoryRuleFormWebComponent) {
    super(component);

    this.initialSetup({
      viewConstructor: IntegrityMonitorDirectoryRuleFormView,
      viewTemplate: template,
    });
  }

  computeEventListeners() {
    return [
      {
        element: this.view.dom.$osFormField.Input,
        event: 'selectionChanged',
        callback: event => {
          this.view.dom.$pathFormField.Input.removeInvalid();
          this.view.dom.$pathFormField.Input.setCurrentOs(this.view.dom.$osFormField.value as string);
          if (event.detail.value) this.view.dom.$actionsForm.refreshOptions(event.detail.value);
        },
      },
    ];
  }

  public resetFields() {
    // discard changes and skip validation
    this.view.formGroup.applyToFormGroupFields(field => {
      if (field instanceof GzFormFieldWebComponent) {
        field.discardChanges();
        field.resetField();
      }
    });
  }
}
